import { render, staticRenderFns } from "./InstallerDashboardItemPage.vue?vue&type=template&id=146edc9e&scoped=true&"
import script from "./InstallerDashboardItemPage.vue?vue&type=script&lang=js&"
export * from "./InstallerDashboardItemPage.vue?vue&type=script&lang=js&"
import style0 from "./InstallerDashboardItemPage.vue?vue&type=style&index=0&id=146edc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146edc9e",
  null
  
)

export default component.exports